import styled from '@emotion/styled'

import media from '../../../styles/media'

const S = {}

S.ToTop = styled.div`
  .to-top {
    position: relative;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 10.25rem;
    width: fit-content;
    height: 2.875rem;
    cursor: pointer;
    font-size: 1rem;
    transition: color 0.2s ease-in-out;

    ${media.md`
      font-size: 1.125rem;
    `};

    &:focus {
      outline: 0.125rem solid rgba(160, 160, 160, 0.75);
      outline-offset: 0;
      box-shadow: none;
    }
  }

  .icon-chevron {
    padding: 0.5625rem;
    width: 0.8125rem;
    transition: stroke 0.2s ease-in-out;

    ${media.md`
      width: 0.9375rem;
    `};
  }
`

export default S
